module.exports = __webpack_public_path__ + "img/1_013.c11d120d.jpg";